export const AI_ACT_GOVERNANCE_VERSION = "2026-07-26";

export const AI_DISCLOSURE_TEXT =
  "You are interacting with Joz MAXX, an AI system. Responses are generated with AI, may be wrong, and require human review before consequential decisions or actions.";

export const AI_OUTPUT_MARKING_SCHEMA = "joz.ai.output-marking.v1";

export function buildAIOutputMetadata({
  systemId = "joz-maxx-chat",
  outputType = "text",
  generated = true,
} = {}) {
  return {
    schema: AI_OUTPUT_MARKING_SCHEMA,
    aiGenerated: generated,
    system: "Joz MAXX",
    systemId,
    outputType,
    governanceVersion: AI_ACT_GOVERNANCE_VERSION,
    disclosure: AI_DISCLOSURE_TEXT,
    humanReviewRequiredForConsequentialUse: true,
    machineReadableMarking: "api-json-metadata-and-response-headers",
  };
}
